module.exports = __webpack_public_path__ + "img/chocolatey-crockpot-cake.6872c6d4.jpg";